export default "__VITE_ASSET__Dn4qgR6Q__"